import { useState, useEffect } from "react";
import logo from "../assets/img/logo.png";
import "./Navbar.css";

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollTo = (id) => {
    setMenuOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <nav className={`navbar${scrolled ? " navbar--scrolled" : ""}`}>
      <button className="navbar__logo" onClick={() => scrollTo("hero")}>
        <img src={logo} alt="Amanimal Shop" className="navbar__logo-img" />
      </button>

      <ul className={`navbar__links${menuOpen ? " navbar__links--open" : ""}`}>
        {[
          { label: "Missão", id: "missao" },
          { label: "Nossa Linha", id: "linha" },
          { label: "Impacto", id: "impacto" },
          { label: "Galeria", id: "galeria" },
          { label: "Produtos", id: "produtos" },
        ].map(({ label, id }) => (
          <li key={id}>
            <button onClick={() => scrollTo(id)}>{label}</button>
          </li>
        ))}
      </ul>

      <button className="navbar__cta" onClick={() => scrollTo("produtos")}>
        Compre e salve vidas
      </button>

      <button
        className="navbar__hamburger"
        aria-label="Menu"
        onClick={() => setMenuOpen((v) => !v)}
      >
        {menuOpen ? "✕" : "☰"}
      </button>
    </nav>
  );
}
